import { toast } from "react-toastify";
import actionType from "../context/actionType";

function isInvalidSession(responseJson) {
  console.info("isInvalid");
  console.info(responseJson.msg);

  console.info(responseJson.code);

  console.info(
    responseJson.msg && responseJson.msg.toLowerCase() === "session not found"
  );

  console.info(responseJson.code !== 10000 && responseJson.code !== 40003);

  return (
    (responseJson.msg &&
      responseJson.msg.toLowerCase() === "session not found") ||
    (responseJson.code !== 10000 && responseJson.code !== 40003)
  );
}

function resetSession(formReducer) {
  toast.error(
    "Session invalid. Please retry the donation again.\n 作業逾時, 請重新選擇捐款項目。\n作业逾时, 请重新选择捐款项目...。"
  );
  sessionStorage.setItem("START_TIME", "");
  sessionStorage.setItem("SESSION_TOKEN", "");
  sessionStorage.removeItem("auth");

  if (formReducer) {
    formReducer.dispatch({
      type: actionType.form.LOGOUT_SUCCESSFUL,
      payload: {},
    });
  }
  setTimeout(() => {
    window.location.href = "https://support.westkowloon.hk/donate-now/";
  }, 8000);
}

export { isInvalidSession, resetSession };
